import Rest from '@/services/Rest';

/**
 * @typedef {RedirectService}
 */
export default class ReportService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/report'
}
